import React, { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { MenuIconButton } from './MenuIconButton';
import { useUser } from '../../../lib/hooks/user';

type Props = {
    defaultCenter?: {
        lat?: number;
        lng?: number;
    };
    previous?: string;
    disableBackButton?: boolean;
};


export const MenuBar: FC<Props> = ({ defaultCenter, previous, disableBackButton = false }) => {

    const user = useUser();

    let menus = [
        { src: '/img/map_menu_bar/icon-stamp.png', href: '/map/stampcard' },
        { src: '/img/map_menu_bar/icon-qr.png', href: '/map/qr' },
        { src: '/img/map_menu_bar/icon-storeplus.png', href: '/map/my_list' },
        { src: '/img/map_menu_bar/icon-list.png', href: '/map/list' },
        { src: '/img/map_menu_bar/icon-hatena.png', href: '/map/help' },
    ];

    let prevPath = "/map";

    if (/\/map\/my_list\/.+/.test(window.location.pathname)) {
        prevPath = document.referrer;
    } else if (/\/map\/stampcard\/.+/.test(window.location.pathname)) {
        prevPath = "/map/stampcard";
    } else if (/\/map\/spot\/.+\/qr/.test(window.location.pathname)) {
        const match = window.location.pathname.match(/\/map\/spot\/*?(\/.*)\/.+/);
        prevPath = match ? `/map/spot${match[1]}/admin` : '/map';
    } else if (/\/map\/spot\/.+\/users/.test(window.location.pathname)) {
        const match = window.location.pathname.match(/\/map\/spot\/*?(\/.*)\/.+/);
        prevPath = match ? `/map/spot${match[1]}/admin` : '/map';
    } else if (/\/map\/spot\/.+\/staff/.test(window.location.pathname)) {
        const match = window.location.pathname.match(/\/map\/spot\/*?(\/.*)\/.+/);
        prevPath = match ? `/map/spot${match[1]}/admin` : '/map';
    } else if (/\/map\/spot\/.+\/admin/.test(window.location.pathname)) {
        const match = window.location.pathname.match(/\/map\/spot\/*?(\/.*)\/.+/);
        prevPath = match ? `/map/spot${match[1]}` : '/map';
    } else if (window.location.pathname === "/map") {
        prevPath = "/";
    }

    return (


        <div className="container_top">


            <div className="profile-header">
                <div className="profile-menu">
                    <a href="/members">
                        <div className="profile-menu-text">
                            <img src="/img/search.png" />
                            <p>プロフィールを検索する</p>
                        </div>
                    </a>
                </div>

                <div className="profile-menuing">
                    <a href="/map">
                        <div className="profile-menu-text">
                            <img src="/img/map.png" />
                            <p>マップでお店を検索する</p>
                        </div>
                    </a>
                </div>

                {/* <div className="profile-menu">
                    <a href="/nomitai">
                        <div className="profile-menu-text">
                            <img src="/img/nomitai.png" />
                            <p>今日呑みたい人を探す</p>
                        </div>
                    </a>
                </div> */}
            </div>

            <div className="container">
                <div className="pageback-button-container">
                    {!disableBackButton && (
                        <Link to={{ pathname: previous ?? prevPath, state: defaultCenter }}>
                            <div className="pageback-arrow"></div>
                        </Link>
                    )}
                </div>
                <div className="nav">
                    {menus.map(({ src, href }) => (
                        <MenuIconButton
                            key={src}
                            src={src}
                            href={href}
                        />
                    ))}
                </div>
            </div>

            <style jsx>{`
                @media (max-width: 768px) {
                    .profile-header{
                        display: none !important;
                    }
                }

                .profile-menu,
                .profile-menuing {
                    height: 50px;
                    background-color: #D6D6D6;
                    width: 50%;
                    border: 1px solid white;
                }

                .profile-menuing {
                    background-color: #F39F65;
                }

                .profile-menu-text {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: auto;
                }

                .profile-menu a{
                    text-decoration: none;
                }
                .profile-menuing a{
                    text-decoration: none;
                }

                .profile-menu-text img {
                    width: 2rem;
                    margin-right: 10px;
                }
                .profile-menu-text p {
                    color: #333;
                    font-size: 14px;
                }
                .profile-header {
                    display: flex;
                    width: 100%;
                    /* justify-content: space-between */
                }
                .storeadd-link {
                    width: 42px;
                }
                .container {
                    display: flex;
                    padding: 6px;
                    justify-content: space-between;
                    align-items: center;
                    min-height: 40px;
                    max-height: 100px;
                    background: #fff;
                    border-bottom: solid 1px rgba(0, 0, 0, 0.04);
                }
                .nav {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    height: 32px;
                }
                .nav > a {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .pageback-button-container {
                    display: flex;
                    align-items: center;
                    curosr: pointer;
                }
                .pageback-arrow{
                    position: relative;
                    display: inline-block;
                    padding: 0 0 0 16px;
                    color: #000;
                    vertical-align: middle;
                    text-decoration: none;
                    font-size: 15px;
                }
                .pageback-arrow::before,
                .pageback-arrow::after{
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    margin: auto;
                    content: "";
                    vertical-align: middle;
                }
                .pageback-arrow::before{
                    left: 14px;
                    width: 10px;
                    height: 10px;
                    border-top: 2px solid black;
                    border-right: 2px solid black;
                    -webkit-transform: rotate(225deg);
                    transform: rotate(225deg);
                }
            `}</style>
        </div>
    );
};
